module.exports = __webpack_public_path__ + "img/album13_06.2176b82a.jpg";